import React, { useState } from "react";
import { AnnsModal } from "../../../components/Component";

export const ModalStatus = {
  success: "success",
  pending: "pending",
};

const RotaEstimateModel = ({ visible, dayLabel, item, onSaved, onClosed, rotaStatus }) => {
  const [queryModal, setQueryModal] = useState(false);

  const close = (result) => {
    onClosed(result);
  };

  return (
    <>
      <AnnsModal
        size={"lg"}
        isOpen={visible}
        toggle={() => close(ModalStatus.pending)}
        title={"Estimates Detail"}
        isFooterHide={true}
      >
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Actual Hours</th>
                <th>Estimate Hours</th>
              </tr>
            </thead>
            <tbody>
              {item?.list?.map((client, index) => (
                <tr key={index}>
                  <td>{client.clientName ?? client.name ?? ""}</td>
                  {client.phone && <td>{`+${client.countryCode} ${client.phone}`}</td>}
                  <td>{client.actualHours ?? ""}</td>
                  <td>{client.estimateHours ?? ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </AnnsModal>
    </>
  );
};

export default RotaEstimateModel;
